import Link from "next/link";
import {Dispatch, SetStateAction} from "react";

interface MenuLinkProps {
    link: string;
    label: string;
    className?: string;
    absolutePath?: boolean;
    setSubactive?: (item: any) => void;
    setSearchValue?: Dispatch<SetStateAction<string>>;
}

const MenuLink = ({ link, label, className, absolutePath = false, setSubactive, setSearchValue }: MenuLinkProps) => {
    if (link === "" && label) {
        return <span className={className}>{label}</span>
    }

    if (link !== "" && label) {
        return (
            <Link href={`${ absolutePath ? "https://" : "" }${link}`} className={className} passHref>
                <span onClick={() => {setSubactive?.(false); setSearchValue?.('')}}>{label}</span>
            </Link>
        )
    }

    return <span className='bg-yellow-100 px-2 py-1 font-mono text-sm text-red-500'>Missing Link Type/Label</span>
}

export { MenuLink }
